// Tripadvisor.js
import React from "react";

const Tripadvisor = () => {
  const links = {
    es: "https://www.tripadvisor.es/Restaurant_Review-g580312-d23529141-Reviews-Nisi_By_Giuseppe-Port_d_Alcudia_Alcudia_Majorca_Balearic_Islands.html",
  };

  return (
    <a
      href={links.es}
      target="_blank"
      rel="noopener noreferrer"
      className="button-styles hover-text"
    >
      <span className="tooltip-text" id="fade">Tripadvisor</span>
      <i className="fa fa-tripadvisor icon-adjusted"></i>
    </a>
  );
};

export default Tripadvisor;
